<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16MJyUo/tc-custom/9781507209615.jpg?1716663163481" alt="This image is the cover for the book Productivity Hacks"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Productivity Hacks
      </h1>
      <p class="bookDescription body article font2">
        <b>Improve your productivity, increase focus, and enhance your organizational and time management skills with these 500+ easy tips and tricks for getting more stuff done. </b><br/><br/>We all know about Post-It notes and to-do lists—and now, with this handy guide you can take productivity to the next level! Learn to use technology to your advantage, schedule your time wisely, and organize your materials for maximum efficiency. Some of <i>Productivity Hacks</i>’s easy-to-implement tips include utilizing “do not disturb” features on your phone and computer to avoid distractions, scheduling a specific time to check your email instead of shifting focus again and again, and creating templates for your most-used email responses so you don’t need to do the same work twice—and many more!<br/><br/>From accomplishing more in the workplace to maintaining a healthy work-life balance, these tips will help hone your focus and time management skills in simple, manageable steps. You’ll be amazed how much more you can achieve over the course of a day!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Emily Price
      </h2>
      
      <p class="authorDescription body article">Emily Price is a freelance tech and travel journalist. Her writing has appeared on <I>Fast Company,</I><I>Fortune</I>, <I>Life Hacker</I>, and <I>Paste Magazine</I>. Follow her on Twitter, @Emily.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Adams Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?17a694e0